module.exports = __webpack_public_path__ + "img/image-filter-center-focus.53b28b15.svg";